import React from "react";
import { PageHeader, Row, Col, Card, Typography } from "antd";
import {
  FunnelPlotOutlined,
  DollarOutlined,
  RiseOutlined,
  PieChartOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const { Text, Title } = Typography;

const REPORTES = [
  {
    key:          "embudo",
    permisoKey:   "permisoReporteEmbudoCRM",
    titulo:       "Oportunidades en Proceso",
    descripcion:
      "Visualiza cuántas oportunidades activas y qué valor económico hay retenido en cada etapa del proceso de cierre hoy en día.",
    icono:        <FunnelPlotOutlined style={{ fontSize: 36, color: "#1890ff" }} />,
    color:        "#e6f7ff",
    borderColor:  "#91d5ff",
    accentColor:  "#1890ff",
  },
  {
    key:          "ganadas",
    permisoKey:   "permisoReporteGanadasCRM",
    titulo:       "Oportunidades Ganadas",
    descripcion:
      "Oportunidades cerradas exitosamente por mes con su valor total. Incluye ticket promedio y ciclo de cierre.",
    icono:        <DollarOutlined style={{ fontSize: 36, color: "#52c41a" }} />,
    color:        "#f6ffed",
    borderColor:  "#b7eb8f",
    accentColor:  "#52c41a",
  },
  {
    key:          "pipeline",
    permisoKey:   "permisoReportePipelineCRM",
    titulo:       "Pipeline & Forecast",
    descripcion:
      "Pronóstico ponderado por probabilidad de cierre de cada etapa. Proyecta el valor esperado del pipeline activo.",
    icono:        <RiseOutlined style={{ fontSize: 36, color: "#722ed1" }} />,
    color:        "#f9f0ff",
    borderColor:  "#d3adf7",
    accentColor:  "#722ed1",
  },
  {
    key:          "leads",
    permisoKey:   "permisoReporteLeadsCRM",
    titulo:       "Origen & Pérdidas",
    descripcion:
      "De dónde vienen tus prospectos y cuáles son los principales motivos por los que se pierden los negocios.",
    icono:        <PieChartOutlined style={{ fontSize: 36, color: "#fa8c16" }} />,
    color:        "#fff7e6",
    borderColor:  "#ffd591",
    accentColor:  "#fa8c16",
  },
  {
    key:          "equipo",
    permisoKey:   "permisoReporteEquipoCRM",
    titulo:       "Ranking de Equipo",
    descripcion:
      "Clasificación de vendedores por monto total ganado y cantidad de leads cerrados exitosamente.",
    icono:        <TeamOutlined style={{ fontSize: 36, color: "#eb2f96" }} />,
    color:        "#fff0f6",
    borderColor:  "#ffadd2",
    accentColor:  "#eb2f96",
  },
];

const ReportesCRM = ({ history, permisoMasterCRM, ...permisos }) => {
  const irA = (key) => history.push(`/panel/crmReportes/${key}`);

  const reportesVisibles = REPORTES.filter((r) => permisoMasterCRM || permisos[r.permisoKey]);

  return (
    <>
      <PageHeader
        title="Reportes CRM"
        subTitle="Selecciona el reporte que deseas consultar"
        onBack={() => history.push("/panel/crmDashboard")}
        style={{
          border: "1px solid rgb(235, 237, 240)",
          backgroundColor: "white",
          marginBottom: 15,
        }}
      />

      <div
        style={{
          backgroundColor: "white",
          border: "1px solid rgb(235, 237, 240)",
          borderRadius: 8,
          padding: "24px",
        }}
      >
        <Row gutter={[20, 20]}>
          {reportesVisibles.map((r) => (
            <Col key={r.key} xs={24} sm={12} lg={8}>
              <Card
                hoverable
                onClick={() => irA(r.key)}
                style={{
                  border: `2px solid ${r.borderColor}`,
                  borderTop: `4px solid ${r.accentColor}`,
                  cursor: "pointer",
                  height: "100%",
                  borderRadius: 8,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                  transition: "box-shadow 0.2s, transform 0.15s",
                }}
                bodyStyle={{ backgroundColor: r.color, borderRadius: 6 }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
                  <div
                    style={{
                      flexShrink: 0,
                      marginTop: 4,
                      width: 52,
                      height: 52,
                      backgroundColor: "white",
                      borderRadius: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: `1px solid ${r.borderColor}`,
                    }}
                  >
                    {r.icono}
                  </div>
                  <div>
                    <Title level={5} style={{ margin: 0, marginBottom: 6, color: "#1a1a2e" }}>
                      {r.titulo}
                    </Title>
                    <Text type="secondary" style={{ fontSize: 13, lineHeight: 1.5 }}>
                      {r.descripcion}
                    </Text>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  permisoMasterCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170cabe0d8ec48005e197f"
    )?.activado,
  permisoReporteEmbudoCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170d05e0d8ec48005e1a2b"
    )?.activado,
  permisoReporteGanadasCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170d1fe0d8ec48005e1a8d"
    )?.activado,
  permisoReportePipelineCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170d5de0d8ec48005e1a95"
    )?.activado,
  permisoReporteLeadsCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170d7de0d8ec48005e1ad8"
    )?.activado,
  permisoReporteEquipoCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170d9ae0d8ec48005e1ae6"
    )?.activado,
});

export default withRouter(connect(mapStateToProps)(ReportesCRM));
